import { render, staticRenderFns } from "./MonthlyReservationStatusByChannel.vue?vue&type=template&id=f2b07c3c&scoped=true&"
import script from "./MonthlyReservationStatusByChannel.vue?vue&type=script&lang=js&"
export * from "./MonthlyReservationStatusByChannel.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyReservationStatusByChannel.vue?vue&type=style&index=0&id=f2b07c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b07c3c",
  null
  
)

export default component.exports